var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragdrop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 4.00016C6.06971 4.00016 6.66667 3.40321 6.66667 2.66683C6.66667 1.93045 6.06971 1.3335 5.33333 1.3335C4.59695 1.3335 4 1.93045 4 2.66683C4 3.40321 4.59695 4.00016 5.33333 4.00016Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.33317C6.06971 9.33317 6.66667 8.73622 6.66667 7.99984C6.66667 7.26346 6.06971 6.6665 5.33333 6.6665C4.59695 6.6665 4 7.26346 4 7.99984C4 8.73622 4.59695 9.33317 5.33333 9.33317Z",
    fill: "#475467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    fill: "#475467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 4.00016C11.4027 4.00016 11.9997 3.40321 11.9997 2.66683C11.9997 1.93045 11.4027 1.3335 10.6663 1.3335C9.92996 1.3335 9.33301 1.93045 9.33301 2.66683C9.33301 3.40321 9.92996 4.00016 10.6663 4.00016Z",
    fill: "#475467"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 9.33317C11.4027 9.33317 11.9997 8.73622 11.9997 7.99984C11.9997 7.26346 11.4027 6.6665 10.6663 6.6665C9.92996 6.6665 9.33301 7.26346 9.33301 7.99984C9.33301 8.73622 9.92996 9.33317 10.6663 9.33317Z",
    fill: "#475467"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 14.6667C11.4027 14.6667 11.9997 14.0697 11.9997 13.3333C11.9997 12.597 11.4027 12 10.6663 12C9.92996 12 9.33301 12.597 9.33301 13.3333C9.33301 14.0697 9.92996 14.6667 10.6663 14.6667Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrop);
export default __webpack_public_path__ + "static/media/dragdrop.7815359ada2bf75565552f3b0486e927.svg";
export { ForwardRef as ReactComponent };